<app-tab-toolbar [tabId]="'collection'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges" (yearChange)="onYearChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<ng-template #reportSection let-cat>
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>{{ cat.label }} Reports</span>
    </div>
    <div class="section-content">
      @for (reportGroup of getReportsByCategory(cat.value); track $index) {
        <div [formGroup]="reportGroup" [appReadOnlyTab]="'collection'" class="report-group">
          <div class="report-row">
            <mat-form-field appearance="fill" class="url-field">
              <mat-label>{{ getUrlLabel(reportGroup) }}</mat-label>
              <input matInput formControlName="url" />
            </mat-form-field>

            @if (reportGroup.get('url')?.value) {
              <button mat-icon-button type="button" matTooltip="Open URL" class="url-btn"
                      (click)="openUrl(reportGroup.get('url')?.value)">
                <mat-icon>open_in_new</mat-icon>
              </button>
            }

            <mat-form-field appearance="fill" class="day-field">
              <mat-label>Day</mat-label>
              <input matInput type="text" inputmode="numeric" appNumberFormat [min]="1" [max]="31" formControlName="day" />
            </mat-form-field>

            <mat-form-field appearance="fill" class="month-field clearable-select-field">
              <mat-label>Month</mat-label>
              <mat-select formControlName="month">
                @for (m of months; track m.value) {
                  <mat-option [value]="m.value">{{ m.label }}</mat-option>
                }
              </mat-select>
              @if (!isReadOnly() && reportGroup.get('month')?.value) {
                <button matSuffix mat-icon-button type="button" tabindex="-1"
                        aria-label="Clear month"
                        (click)="$event.stopPropagation(); clearControl(reportGroup.get('month'))">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          </div>

          @let flags = getTypeFlags(reportGroup);
          @if (flags) {
            <div class="type-flags">
              @for (flag of flags; track flag.bit) {
                <mat-checkbox [formControlName]="'typeBit' + flag.bit"
                              (change)="onTypeFlagChange(reportGroup)">
                  {{ flag.label }}
                </mat-checkbox>
              }
            </div>
          }
        </div>
      } @empty {
        <div class="empty-message">No reports added</div>
      }
    </div>
  </section>
</ng-template>

<div class="container column-layout" [formGroup]="form" [appReadOnlyTab]="'collection'">
  <section class="section-container fiscal-year-section nrg-border-radius-second-level">
    <div class="section-header">
      Fiscal Year End
    </div>
    <div class="section-content section-content-row fiscal-year-controls">
      <mat-form-field appearance="fill" class="day-field">
        <mat-label>Day</mat-label>
        <input matInput type="text" inputmode="numeric" appNumberFormat [min]="1" [max]="31" formControlName="fiscalYearEndDay" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="month-field clearable-select-field">
        <mat-label>Month</mat-label>
        <mat-select formControlName="fiscalYearEndMonth">
          @for (m of months; track m.value) {
            <mat-option [value]="m.value">{{ m.label }}</mat-option>
          }
        </mat-select>
        @if (!isReadOnly() && form.get('fiscalYearEndMonth')?.value) {
          <button matSuffix mat-icon-button type="button" tabindex="-1"
                  aria-label="Clear month"
                  (click)="$event.stopPropagation(); clearControl(form.get('fiscalYearEndMonth'))">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </section>

  <div class="columns-wrapper">
    <div class="column">
      @for (cat of leftCategories; track cat.value) {
        <ng-container [ngTemplateOutlet]="reportSection" [ngTemplateOutletContext]="{ $implicit: cat }"></ng-container>
      }
    </div>
    <div class="column">
      @for (cat of rightCategories; track cat.value) {
        <ng-container [ngTemplateOutlet]="reportSection" [ngTemplateOutletContext]="{ $implicit: cat }"></ng-container>
      }
    </div>
  </div>

  <section class="section-container data-collection-section nrg-border-radius-second-level">
    <div class="section-header">
      Data Collection
    </div>
    <div class="section-content section-content-row">
      <div class="terms-field">
        <mat-checkbox formControlName="terms">Terms</mat-checkbox>
      </div>
      <div class="comments-field">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Comments</mat-label>
          <textarea matInput formControlName="comments" rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>
  </section>
</div>
